import { ColumnType } from 'antd/lib/table'
import { MaterialRequirement } from '../../../../types/api/components/material/material-requirements'
import AdditionalJob from '../../../../types/api/additional-job'
import PrintJob from '../../../../types/api/print-job'
import PrintQueueEntry from '../../../../types/api/print-queue-entry'
import Shipment from '../../../../types/api/shipment'
import ShipmentAdditionalInfoCell from '../../../shipments/components/cells/additional-info/shipment-additional-info-cell'
import CuratorPrintTag from '../../../shipments/components/cells/curator-print/curator-print-tag'
import StampTubeCell from '../components/cells/stamp-tube-cell'
import TsAndLm from '../components/cells/ts-and-lm'

export const tsAndLm = {
    dataIndex: ['shipment', 'materialRequirements'],
    title: 'ТС / ЛМ',
    width: 60,
    render(v: MaterialRequirement[]) {
        return <TsAndLm materialRequirements={v} />
    },
}

export const printQueueFormSetIdColumn: ColumnType<PrintQueueEntry> = {
    title: 'Набор форм',
    width: 70,
    dataIndex: ['print_job', 'shipment', 'form_set', 'id'],
    render: (v: number | undefined) => v ?? '—',
}

export const printJobFormSetIdColumn: ColumnType<PrintJob> = {
    title: 'Набор форм',
    width: 70,
    dataIndex: ['shipment', 'form_set', 'id'],
    render: (v: number | undefined) => v ?? '—',
}

export const createStampTubeColumn = <T,>(
    getShipment: (record: T) => Shipment | undefined
): ColumnType<T> => ({
    title: 'Штамп',
    width: 60,
    render: (_, record) => <StampTubeCell shipment={getShipment(record)} />,
})

export const createAdditionalInfoColumn = <T,>(
    getShipment: (record: T) => Shipment | undefined
): ColumnType<T> => ({
    title: 'Доп.',
    width: 44,
    render: (_, record) => {
        const shipment = getShipment(record)
        if (!shipment) return '—'

        return <ShipmentAdditionalInfoCell shipment={shipment} variant='people' />
    },
})

export function createAdditionalJobsColumn(prefix: (string | number)[] = []) {
    return {
        dataIndex: [...prefix, 'additional_jobs'],
        title: 'Доп. работы',
        width: 80,
        render(v: AdditionalJob[]) {
            return v?.map(x => x.name).join(', ') || ''
        },
    }
}

export const additionalJobs = createAdditionalJobsColumn(['shipment'])

export const createCuratorPrintColumn = <T,>(
    getShipment: (record: T) => Shipment | undefined
): ColumnType<T> => ({
    title: 'К',
    width: 40,
    render: (_, record) => <CuratorPrintTag shipment={getShipment(record)} />,
})
